export const getIndex = (pageNumber: number, pageSize: number, idx: number) => {
  return idx + 1 + pageSize * pageNumber;
};
